/* eslint-disable */
import React, { useContext, useState } from 'react';
import { Button, DatePicker, WeekPicker } from '@rentacenter/legacyracstrap';
import { add, format, isSameDay, startOfWeek, sub } from 'date-fns';

import styles from './Goals.module.scss';

import { StoreGoals } from './StoreGoals/StoreGoals';
import { SalesGoals } from './SalesGoals/SalesGoals';
import { CollectionGoals } from './CollectionGoals/CollectionGoals';
import { StoreContext } from '../../../context/Storeprovider';
export const goalsTestId = 'goalsCoreUserTestId';
import { useTranslation } from 'react-i18next';

export const GoalsCoreUser = () => {
  const{t} = useTranslation('calendar');
  const today = new Date();
  const [week, setWeek] = useState<Date>(startOfWeek(today));
  const { storeGoalsSelectedDate, setStoreGoalsSelectedDate } = useContext(
    StoreContext
  );
  const language = window.sessionStorage.getItem('language');


  const getTranslatedWeekLabel = (date: Date) => {
    const month = format(date, 'MMM'); // e.g., "Jun"
    const day = format(date, 'd'); // e.g., "1"

    
    if (language == 'es-MX' || language == 'es-US') {
      return `${t('Week of')} ${t(month)} ${day}`; 
    }
    
    return `Week of ${month} ${day}`;
  };

   const getTranslatedDateLabel = (date: Date) => {
    const weekday = format(date, 'eee'); // e.g., "Wed"
    const month = format(date, 'MMM'); // e.g., "Jun"
    const day = format(date, 'd'); // e.g., "04"
    const year = format(date, 'yyyy'); // e.g., "2025"

    if (language == 'es-MX' || language == 'es-US') {
      return `${t(weekday)} ${t(month)} ${day}, ${year}`; // Translate weekday and month
    }

    // Return the date label in English if not Spanish
    return `${weekday}, ${month} ${day}, ${year}`;
  };

  return (
    <div data-testid={goalsTestId} className={styles.goals}>
      <div className={styles.datesRow}>
        <div className={styles.datePickerWrap}>
          <DatePicker
            value={storeGoalsSelectedDate}
            className={`${styles.datePicker} ${styles.custweekpicker}`}
            name="date"
            placeholder={t("Select a date")}
            onChange={setStoreGoalsSelectedDate}
            datePickerProps={{
              labelFunc: (date) => getTranslatedDateLabel(date), 
            }}
            format="eee, MMM dd, yyyy"
          />
          <Button
            data-testid="todayBtn"
            variant="outlined"
            disabled={isSameDay(storeGoalsSelectedDate, new Date())}
            onClick={() => setStoreGoalsSelectedDate(new Date())}
            className={styles.todayBtn}
          >
            {t('Today')}
          </Button>
        </div>
      </div>

      <div className={styles.section}>
        <h3>{t('Store Goals')}</h3>
        <StoreGoals startDate={week} />
      </div>
      <WeekPicker
        className={`${styles.weekPicker} ${styles.custweekpicker}`}
        name="weekPicker"
        datePickerProps={{
          maxDate: add(today, { years: 1 }),
          minDate: sub(today, { years: 1 }),
           labelFunc: (date) => getTranslatedWeekLabel(date),
        }}
        value={week}
        onChange={setWeek}
      />
      <div className={styles.section}>
        <h3>{t('Sales Goals')}</h3>
        <SalesGoals startDate={week} />
      </div>

      <div className={styles.section}>
        <h3>{t('Collection Goals')}</h3>
        <CollectionGoals startDate={week} />
      </div>
    </div>
  );
};
